import styled from 'styled-components/macro'

export const Input = styled.input`
  width: 250px;
  height: 30px;
  margin-bottom: 6px;
  padding: 5px;
  border: none;
  border-radius: 3px;
  background: #c2d6cc;
  font-size: 16px;
  cursor: pointer;
`